import IconButton from "@mui/material/IconButton";
import ListSubheader from "@mui/material/ListSubheader";
import Divider from "@mui/material/Divider";
import CollectionImportStatus from "./CollectionImportStatus";
import MenuSurface from "../ui/MenuSurface";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";
import { flushSync } from "react-dom";
import Link from "../ui/RouterLink";
import { isCollectionImportActive } from "../utils/collectionImport";
function Menu({
  open,
  setOpen,
  onImport,
  canImport,
  role,
  importStatus,
  startingImport = false,
  onCancelImport,
  onSignOut,
  signingOut = false,
}) {
  const [menuAnchor, setMenuAnchor] = React.useState(null);
  const menuRef = React.useRef(null);
  React.useEffect(() => {
    if (open && !menuAnchor)
      setMenuAnchor(menuRef.current?.querySelector("button"));
  }, [open, menuAnchor]);
  const listRef = React.useRef(null);
  const startFocused = React.useRef(false);
  const active = isCollectionImportActive(importStatus);
  const busy = startingImport || active;
  React.useLayoutEffect(() => {
    if (busy && startFocused.current) {
      listRef.current?.focus();
      startFocused.current = false;
    }
  }, [busy]);
  return (
    <div className="menu" ref={menuRef}>
      <IconButton
        type="button"
        className="menu-toggle"
        onClick={(event) => {
          setMenuAnchor(event.currentTarget);
          setOpen((o) => !o);
        }}
        aria-label="Menu"
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <MenuIcon />
      </IconButton>
      {open && menuAnchor && (
        <MenuSurface
          anchorEl={menuAnchor}
          positionAnchorEl={menuAnchor.querySelector("svg") || menuAnchor}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          listRef={listRef}
          onClose={() => {
            startFocused.current = false;
            setOpen(false);
          }}
        >
          {canImport && (
            <>
              {busy ? (
                <ListSubheader
                  disableSticky
                  tabIndex={-1}
                  sx={{ lineHeight: "normal", py: 1, color: "text.primary" }}
                >
                  <CollectionImportStatus
                    status={importStatus}
                    starting={startingImport}
                  />
                </ListSubheader>
              ) : (
                <MenuItem
                  className="import-btn"
                  component="button"
                  onClick={() => {
                    startFocused.current = true;
                    onImport();
                  }}
                >
                  Import collection
                </MenuItem>
              )}
              {active && !startingImport && (
                <MenuItem
                  component="button"
                  disabled={importStatus.status === "stopping"}
                  sx={{ color: "error.main" }}
                  onClick={() => {
                    flushSync(() => setOpen(false));
                    onCancelImport();
                  }}
                >
                  Stop import
                </MenuItem>
              )}
              <Divider />
            </>
          )}
          <MenuItem to="/sets" onClick={() => setOpen(false)} component={Link}>
            My Sets
          </MenuItem>
          <MenuItem
            to="/archived"
            onClick={() => setOpen(false)}
            component={Link}
          >
            Archived Releases
          </MenuItem>
          {role === "admin" && (
            <MenuItem
              to="/admin"
              onClick={() => setOpen(false)}
              component={Link}
            >
              Admin Hub
            </MenuItem>
          )}
          <MenuItem
            to="/settings"
            onClick={() => setOpen(false)}
            component={Link}
          >
            User Settings
          </MenuItem>
          <Divider />
          <MenuItem
            component="button"
            onClick={onSignOut}
            disabled={signingOut}
          >
            {signingOut ? "Signing Out…" : "Sign Out"}
          </MenuItem>
        </MenuSurface>
      )}
    </div>
  );
}
export default Menu;
